import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Building2, Package, TrendingUp, Shield } from 'lucide-react';
import { testimonials } from '../data/mock';

const Home = () => {
  useEffect(() => {
    // Load Instagram embed script
    const script = document.createElement('script');
    script.src = '//www.instagram.com/embed.js';
    script.async = true;
    document.body.appendChild(script);
    
    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <div>
      {/* Hero Section */}
      <section className="section-padding" style={{ background: 'var(--bg-primary)' }}>
        <div className="container">
          <div style={{
            maxWidth: '900px',
            margin: '0 auto',
            textAlign: 'center'
          }}>
            <h1 className="hero-large" style={{ marginBottom: '24px' }}>
              Caring Health & Wealth — Under One Roof
            </h1>
            <p className="body-large" style={{
              color: 'var(--text-secondary)',
              marginBottom: '48px',
              maxWidth: '700px',
              margin: '0 auto 48px'
            }}>
              India's fast-emerging pharmacy retail chain with 190+ stores, 35,000+ SKUs, and a commitment to quality healthcare at transparent prices.
            </p>
            <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}>
              <Link to="/stores" className="btn-primary">
                Find a Store
                <ArrowRight size={16} />
              </Link>
              <Link to="/franchise" className="btn-secondary">
                Explore Franchise
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Trust Highlights */}
      <section className="section-padding-small" style={{ background: 'var(--bg-secondary)' }}>
        <div className="container">
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '48px'
          }}>
            <div style={{ textAlign: 'center' }}>
              <div className="hero-medium" style={{ marginBottom: '8px', color: 'var(--brand-blue)' }}>190+</div>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>Stores PAN-India</p>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div className="hero-medium" style={{ marginBottom: '8px', color: 'var(--brand-green)' }}>35,000+</div>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>Products (SKUs)</p>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div className="hero-medium" style={{ marginBottom: '8px', color: 'var(--brand-blue)' }}>20%</div>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>Flat Discount on Medicines</p>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div className="hero-medium" style={{ marginBottom: '8px', color: 'var(--brand-green)' }}>24/7</div>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>Home Delivery Support</p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Care Pharmacy */}
      <section className="section-padding" style={{ background: 'var(--bg-primary)' }}>
        <div className="container">
          <h2 className="hero-medium" style={{ marginBottom: '60px', textAlign: 'center' }}>
            Why Families Trust Care Pharmacy
          </h2>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '40px'
          }}>
            <div className="hover-lift" style={{ padding: '32px', background: 'var(--bg-secondary)', borderRadius: '0px' }}>
              <Package size={32} style={{ color: 'var(--brand-blue)', marginBottom: '16px' }} />
              <h3 className="heading-2" style={{ marginBottom: '12px' }}>Wide Availability</h3>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                Comprehensive stock of branded, generic, OTC medicines, surgical supplies, and wellness products.
              </p>
            </div>
            <div className="hover-lift" style={{ padding: '32px', background: 'var(--bg-secondary)', borderRadius: '0px' }}>
              <TrendingUp size={32} style={{ color: 'var(--brand-green)', marginBottom: '16px' }} />
              <h3 className="heading-2" style={{ marginBottom: '12px' }}>Assured Savings</h3>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                Transparent pricing with flat 20% discount on all medicines including insulins and specialty drugs.
              </p>
            </div>
            <div className="hover-lift" style={{ padding: '32px', background: 'var(--bg-secondary)', borderRadius: '0px' }}>
              <Shield size={32} style={{ color: 'var(--brand-blue)', marginBottom: '16px' }} />
              <h3 className="heading-2" style={{ marginBottom: '12px' }}>Professional Care</h3>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                Licensed pharmacists provide expert guidance, ensuring safe and accurate medication dispensing.
              </p>
            </div>
            <div className="hover-lift" style={{ padding: '32px', background: 'var(--bg-secondary)', borderRadius: '0px' }}>
              <Building2 size={32} style={{ color: 'var(--brand-green)', marginBottom: '16px' }} />
              <h3 className="heading-2" style={{ marginBottom: '12px' }}>Convenient Service</h3>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                Home delivery, WhatsApp ordering, diagnostic tie-ups, and in-store OPD at select locations.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Video */}
      <section className="section-padding" style={{ background: 'var(--bg-secondary)' }}>
        <div className="container">
          <h2 className="hero-medium" style={{ marginBottom: '24px', textAlign: 'center' }}>
            Experience Care Pharmacy
          </h2>
          <p className="body-large" style={{
            color: 'var(--text-secondary)',
            marginBottom: '60px',
            textAlign: 'center',
            maxWidth: '700px',
            margin: '0 auto 60px'
          }}>
            Discover how we're transforming healthcare retail across India with quality, affordability, and professional care.
          </p>
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            maxWidth: '900px',
            margin: '0 auto'
          }}>
            <video
              controls
              style={{
                width: '100%',
                maxWidth: '900px',
                borderRadius: '0px',
                border: '1px solid var(--border-light)',
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)'
              }}
            >
              <source src="/care-pharmacy-video.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="section-padding" style={{ background: 'var(--bg-primary)' }}>
        <div className="container">
          <h2 className="hero-medium" style={{ marginBottom: '60px', textAlign: 'center' }}>
            What Our Customers Say
          </h2>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '32px'
          }}>
            {testimonials.map((testimonial) => (
              <div key={testimonial.id} className="hover-lift" style={{
                padding: '32px',
                background: 'var(--bg-primary)',
                borderRadius: '0px',
                border: '1px solid var(--border-light)'
              }}>
                <p className="body-regular" style={{
                  color: 'var(--text-primary)',
                  marginBottom: '24px',
                  fontStyle: 'italic'
                }}>
                  "{testimonial.text}"
                </p>
                <div>
                  <p className="body-regular" style={{ fontWeight: '500', marginBottom: '4px' }}>
                    {testimonial.name}
                  </p>
                  <p className="body-small" style={{ color: 'var(--text-secondary)' }}>
                    {testimonial.location}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Store Showcase & Events */}
      <section className="section-padding" style={{ background: 'var(--bg-primary)' }}>
        <div className="container">
          <h2 className="hero-medium" style={{ marginBottom: '60px', textAlign: 'center' }}>
            Our Stores & Community Impact
          </h2>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '24px'
          }}>
            <div className="hover-lift" style={{
              overflow: 'hidden',
              borderRadius: '0px',
              border: '1px solid var(--border-light)'
            }}>
              <img 
                src="/images/care_pharmacy_1.jpeg" 
                alt="Care Pharmacy Store Interior"
                style={{
                  width: '100%',
                  height: '280px',
                  objectFit: 'cover',
                  transition: 'transform 0.3s ease'
                }}
                onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
              />
            </div>
            <div className="hover-lift" style={{
              overflow: 'hidden',
              borderRadius: '0px',
              border: '1px solid var(--border-light)'
            }}>
              <img 
                src="/images/events/event_22.jpg" 
                alt="Care Pharmacy Services"
                style={{
                  width: '100%',
                  height: '280px',
                  objectFit: 'cover',
                  transition: 'transform 0.3s ease'
                }}
                onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
              />
            </div>
            <div className="hover-lift" style={{
              overflow: 'hidden',
              borderRadius: '0px',
              border: '1px solid var(--border-light)'
            }}>
              <img 
                src="/images/events/event_27.jpg" 
                alt="Care Pharmacy Events"
                style={{
                  width: '100%',
                  height: '280px',
                  objectFit: 'cover',
                  transition: 'transform 0.3s ease'
                }}
                onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
              />
            </div>
            <div className="hover-lift" style={{
              overflow: 'hidden',
              borderRadius: '0px',
              border: '1px solid var(--border-light)'
            }}>
              <img 
                src="/images/events/event_30.jpg" 
                alt="Community Service"
                style={{
                  width: '100%',
                  height: '280px',
                  objectFit: 'cover',
                  transition: 'transform 0.3s ease'
                }}
                onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
              />
            </div>
            <div className="hover-lift" style={{
              overflow: 'hidden',
              borderRadius: '0px',
              border: '1px solid var(--border-light)'
            }}>
              <img 
                src="/images/care_pharmacy_3.jpeg" 
                alt="Product Range"
                style={{
                  width: '100%',
                  height: '280px',
                  objectFit: 'cover',
                  transition: 'transform 0.3s ease'
                }}
                onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
              />
            </div>
            <div className="hover-lift" style={{
              overflow: 'hidden',
              borderRadius: '0px',
              border: '1px solid var(--border-light)'
            }}>
              <img 
                src="/images/events/event_15.jpg" 
                alt="Care Pharmacy Services"
                style={{
                  width: '100%',
                  height: '280px',
                  objectFit: 'cover',
                  transition: 'transform 0.3s ease'
                }}
                onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
              />
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section-padding" style={{ background: 'var(--bg-secondary)' }}>
        <div className="container">
          <div style={{
            maxWidth: '800px',
            margin: '0 auto',
            textAlign: 'center',
            padding: '60px 40px',
            background: 'var(--bg-primary)',
            borderRadius: '0px'
          }}>
            <h2 className="hero-medium" style={{ marginBottom: '24px' }}>
              Join India's Growing Pharmacy Network
            </h2>
            <p className="body-large" style={{
              color: 'var(--text-secondary)',
              marginBottom: '40px'
            }}>
              Explore franchise opportunities with transparent models, centralised support, and minimum-guarantee returns.
            </p>
            <Link to="/franchise" className="btn-primary">
              Learn About Franchise
              <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;